
export interface PaymentMethod {
    id: string;
    name: string;
    imageUrl: string;
    backgroundColor: string;
    type: 'card' | 'banking' | 'digital_wallet' | 'cash';
    category: 'card' | 'other';
}

export const PAYMENT_METHODS: PaymentMethod[] = [
    // Card Payment Methods
    {
        id: 'visa',
        name: 'Visa',
        imageUrl: '/img/payment-methods/visa.svg',
        backgroundColor: 'bg-blue-600',
        type: 'card',
        category: 'card'
    },
    {
        id: 'mastercard',
        name: 'Mastercard',
        imageUrl: '/img/payment-methods/mastercard.svg',
        backgroundColor: 'bg-gray-700',
        type: 'card',
        category: 'card'
    },
    // Other Payment Methods
    {
        id: 'codensa',
        name: 'Codensa',
        imageUrl: '/img/payment-methods/codensa.svg',
        backgroundColor: 'bg-yellow-400',
        type: 'card',
        category: 'card'
    },
    {
        id: 'diners',
        name: 'Diners Club',
        imageUrl: '/img/payment-methods/dinners.svg',
        backgroundColor: 'bg-blue-800',
        type: 'card',
        category: 'card'
    },
    {
        id: 'amex',
        name: 'American Express',
        imageUrl: '/img/payment-methods/AM.svg',
        backgroundColor: 'bg-[#2E77BC]',
        type: 'card',
        category: 'card'
    },
    {
        id: 'pse',
        name: 'PSE',
        imageUrl: '/img/payment-methods/pseNew.svg',
        backgroundColor: 'bg-blue-800',
        type: 'banking',
        category: 'other'
    },
    {
        id: 'davivienda',
        name: 'Davivienda',
        imageUrl: '/img/payment-methods/davivienda.svg',
        backgroundColor: 'bg-red-500',
        type: 'banking',
        category: 'other'
    },
    {
        id: 'daviplata',
        name: 'DaviPlata',
        imageUrl: '/img/payment-methods/daviplata.svg',
        backgroundColor: 'bg-red-500',
        type: 'digital_wallet',
        category: 'other'
    },
    {
        id: 'bancolombia',
        name: 'Bancolombia',
        imageUrl: '/img/payment-methods/bancolombia.svg',
        backgroundColor: 'bg-[#2C2A29]',
        type: 'banking',
        category: 'other'
    },
    {
        id: 'nequi',
        name: 'Nequi',
        imageUrl: '/img/payment-methods/nequi.svg',
        backgroundColor: 'bg-[#F3F3F5] border border-gray-300',
        type: 'digital_wallet',
        category: 'other'
    },
    {
        id: 'sured',
        name: 'Su Red',
        imageUrl: '/img/payment-methods/Su-red-azul.png',
        backgroundColor: 'bg-white border border-gray-300',
        type: 'banking',
        category: 'other'
    },
    {
        id: 'efecty',
        name: 'Efecty',
        imageUrl: '/img/payment-methods/efecty.svg',
        backgroundColor: 'bg-yellow-400',
        type: 'cash',
        category: 'other'
    },
    {
        id: 'gana',
        name: 'Gana',
        imageUrl: '/img/payment-methods/gana.svg',
        backgroundColor: 'bg-green-400',
        type: 'cash',
        category: 'other'
    },
    {
        id: 'puntored',
        name: 'Puntored',
        imageUrl: '/img/payment-methods/puntored.svg',
        backgroundColor: 'bg-pink-500',
        type: 'cash',
        category: 'other'
    },
    {
        id: 'servi',
        name: 'Red Servi',
        imageUrl: '/img/payment-methods/servi.svg',
        backgroundColor: 'bg-[#009E3D]',
        type: 'cash',
        category: 'other'
    },
    {
        id: 'todopago',
        name: 'Paga Todo',
        imageUrl: '/img/payment-methods/todo.png',
        backgroundColor: 'bg-[#E0001A]',
        type: 'cash',
        category: 'other'
    },
    {
        id: 'suchance',
        name: 'Su Chance',
        imageUrl: '/img/payment-methods/suchance.png',
        backgroundColor: 'bg-[#001E5D]',
        type: 'cash',
        category: 'other'
    },
    {
        id: 'puntoscolombia',
        name: 'Puntos Colombia',
        imageUrl: '/img/payment-methods/puntos-colombia.svg',
        backgroundColor: 'bg-[#EFEFEF] border border-gray-300',
        type: 'digital_wallet',
        category: 'other'
    },
    {
        id: 'safetypay',
        name: 'SafetyPay',
        imageUrl: '/img/payment-methods/safelypay.svg',
        backgroundColor: 'bg-blue-600',
        type: 'digital_wallet',
        category: 'other'
    },
    {
        id: 'paypal',
        name: 'PayPal',
        imageUrl: '/img/payment-methods/paypal.svg',
        backgroundColor: 'bg-[#EFEFEF] border border-gray-300',
        type: 'digital_wallet',
        category: 'other'
    }
];
